<template>
  <div class="report-view">
    <el-row :gutter="24" class="row-level">
      <el-col :span="8">
        <monitor-item
          icon="el-icon-s-data"
          bg="#e6f7ff"
          color="#40a9ff"
          label="总使用数"
          :value="count"
          @click="$router.push('/TestReport')"
          style="cursor: pointer"
        ></monitor-item>
      </el-col>
      <el-col :span="8">
        <monitor-item
          icon="el-icon-s-flag"
          bg="#f9f0ff"
          color="#9254de"
          label="本月使用数"
          :value="countByMonth"
        ></monitor-item>
      </el-col>
      <el-col :span="8">
        <monitor-item
          icon="el-icon-s-promotion"
          bg="#fff7e6"
          color="#ffa940"
          label="当天使用数"
          :value="countByDay"
        ></monitor-item>
      </el-col>
    </el-row>
    <div class="rank-top-wrap">
      <div class="rank-top">
        <h4>当天使用排行</h4>
      </div>
      <sort-list :rows="sortList"></sort-list>
    </div>
  </div>
</template>
<script>
export default {
  name: 'report-view',
  data() {
    return {
      sortList: [],
      count: 0,
      countByMonth: 0,
    }
  },
  computed: {
    countByDay() {
      var count = 0
      for (var item of this.sortList) {
        count += item.value || 0
      }
      return count
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$get('/testReport/reportView').then((resp) => {
        if (resp.data.code == 0) {
          this.sortList = this.convertSortList(resp.data.data.sortList || [])
          this.count = resp.data.data.count
          this.countByMonth = resp.data.data.countByMonth
        } else {
          this.$message(resp.data.msg || '获取数据失败')
        }
      })
    },
    convertSortList(rows) {
      var list = []
      for (var row of rows) {
        list.push({
          store_code: row.store_code,
          store_name: row.store_name,
          value: row.count,
        })
      }
      return list
    },
  },
}
</script>
<style lang="less">
.report-view {
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  .rank-top-wrap {
    padding: 0 16px 16px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
  }
  .row-level {
    margin-bottom: 24px;
  }
  .rank-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>